<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
<button :class="{
  'py-1 px-3 hover:bg-metal-500 rounded text-metal-300 transition-all duration-100 ease-out btn-3d': true,
  'bg-metal-700': active,
  'bg-metal-600': !active,
  'w-full': fullWidth
}">
  <slot></slot>
</button>
</template>

<style scoped lang="scss">
.btn-3d {
  background-image: linear-gradient(to bottom, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
  box-shadow: 0 2px 0 rgba(0,0,0,0.3);
  transform: translateY(0);

  :deep(img) {
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.4));
  }

  &:active {
    box-shadow: 0 0 0 rgba(0,0,0,0.3);
    transform: translateY(2px);
  }
}
</style>